export default __webpack_public_path__ + "static/media/marketing-mobi2.483b49f6.png";